import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'searchfilter',
    standalone: true,
})
export class SearchfilterPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items || !searchText) {
      return items;
    }

    searchText = searchText.toLowerCase();

    return items.filter((item) => {
      return item.city.toLowerCase().includes(searchText);
    });
  }
}
